import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import {
  faFile,
  faFileAudio,
  faFileImage,
  faFilePdf,
  faFileVideo,
} from '@fortawesome/pro-regular-svg-icons';

const ICON_BY_MIME_TYPE = {
  'image/': faFileImage,
  'audio/': faFileAudio,
  'video/': faFileVideo,
  'application/pdf': faFilePdf,
  '?': faFile,
};

export const getIconFromMimeType = (mimeType?: string): IconDefinition => {
  if (!mimeType) {
    return ICON_BY_MIME_TYPE['?'];
  }

  const keys = Object.keys(ICON_BY_MIME_TYPE) as Array<
    keyof typeof ICON_BY_MIME_TYPE
  >;
  const matchingKey =
    keys.find((key) =>
      (key.endsWith('/') ? mimeType.startsWith(key) : mimeType === key)
        ? key
        : undefined,
    ) ?? '?';
  const iconName = ICON_BY_MIME_TYPE[matchingKey];

  return iconName;
};
